import optimizedSources from '../components/configurator/optimizedImageSources.json';

// Reviewed originals and provenance remain in the registries. Only delivery
// URLs change, and only for copies proven identical in RGBA, size and profile.
export const configuratorImage = src => optimizedSources[src] || src;

export function optimizedPhotographicScene(scene) {
  return {
    ...scene,
    ...Object.fromEntries(['body', 'ribbon', 'bodyMask', 'junctionMask', 'junctionOverlay']
      .map(key => [key, configuratorImage(scene[key])])),
    ...(scene.bodyPanels ? {bodyPanels: scene.bodyPanels.map(panel => ({...panel, src: configuratorImage(panel.src)}))} : {}),
  };
}
